export class AddressDto {
  state: string;
  city: string;
  neighborhood: string;
  address: string;
  number: string;
  complement?: string;
  zipcode: string;
}